module.exports = require("./../../_gen/starling/filters/BlurFilter");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/filters/BlurFilter.js
// module id = 197
// module chunks = 0